import { createFileRoute } from "@tanstack/react-router"

import { WrongSessionType } from "@/sections/other/WrongSessionType"
import { useSessionDetail } from "@/services/dexie"

import { ClientRedirect } from "../../../components/ClientRedirect"
import { SpinnerLayout } from "../../../components/layouts/SpinnerLayout"
import { LINKS } from "../../../routing/links"
import { useStepsRouting } from "../../../routing/useStepsRouting"

export const Route = createFileRoute("/$sessionId/_session/")({
  component: IndexRoute,
})

function IndexRoute() {
  const { sessionId } = Route.useParams()
  const { firstUnfinishedStepLink, isLoading: isLoadingSteps } = useStepsRouting(sessionId)
  const { data: sessionDetail, isLoading: isLoadingSessionDetail } = useSessionDetail(sessionId)

  if (isLoadingSteps || isLoadingSessionDetail) return <SpinnerLayout />

  if (sessionDetail?.type === "API") {
    return <WrongSessionType />
  }

  return <ClientRedirect to={firstUnfinishedStepLink ?? LINKS.finish(sessionId)} />
}
